import { jsxs, jsx } from 'react/jsx-runtime';
import { ContextMenu } from '@fabric-app/ui/components/ContextMenu/ContextMenu';
import { DropdownItemIconContainer } from '@fabric-app/ui/components/DropdownMenu/Item';
import plur from 'plur';
import { copyResourcesToClipboard } from '../../utils/resourceCopy/copyResourceToClipboard.js';
import { IconCopy } from '@fabric-app/icons/svg';
import { useQueryUserInfo } from '../../../user/queries/useQueryUserInfo.js';

const ContextMenuCopyResources = ({ resources }) => {
  const { isAuthenticated } = useQueryUserInfo();
  return /* @__PURE__ */ jsxs(ContextMenu.Sub, {
    children: [
      /* @__PURE__ */ jsxs(ContextMenu.SubTrigger, {
        children: [
          /* @__PURE__ */ jsx(DropdownItemIconContainer, {
            children: /* @__PURE__ */ jsx(IconCopy, {})
          }),
          "Copy",
          /* @__PURE__ */ jsx(ContextMenu.ChevronRight, {})
        ]
      }),
      /* @__PURE__ */ jsx(ContextMenu.Portal, {
        children: /* @__PURE__ */ jsxs(ContextMenu.SubContent, {
          children: [
            isAuthenticated && /* @__PURE__ */ jsxs(ContextMenu.Item, {
              onClick: () => {
                copyResourcesToClipboard({
                  action: "copy",
                  resources
                });
              },
              children: [
                "Copy ",
                plur("item", resources.length)
              ]
            }),
            /* @__PURE__ */ jsxs(ContextMenu.Item, {
              onClick: () => {
                copyResourcesToClipboard({
                  action: "copy",
                  resources
                }, {
                  addResourcesToClipboardData: false
                });
              },
              children: [
                "Copy item URL",
                resources.length > 1 && "s"
              ]
            })
          ]
        })
      })
    ]
  });
};

export { ContextMenuCopyResources };
//# sourceMappingURL=ContextMenuCopyResources.js.map
